import type {PhotoCheckerPhotoTypeSaleVehiclePhoto} from '@dms/api/vehicle';

import type {PhotoCheckerSilhouettePart} from '../types/PhotoCheckerSilhouettePart';

export const photoCheckerPhotoTypesByPart = {
  frontLeft: ['FRONT_LEFT'],
  frontRight: ['FRONT_RIGHT'],
  rearLeft: ['REAR_LEFT'],
  rear: ['REAR'],
  rearRight: ['REAR_RIGHT'],
  front: ['FRONT'],
  leftSide: ['LEFT_SIDE'],
  rightSide: ['RIGHT_SIDE'],
  steeringWheel: ['STEERING_WHEEL'],
  frontSeats: ['FRONT_SEATS'],
  backSeats: ['BACK_SEATS'],
  trunk: ['TRUNK'],
  infotainment: ['DASHBOARD_WITH_TURNEDON_INFOTAINMENT', 'DASHBOARD_WITH_TURNEDOFF_INFOTAINMENT'],
  dashboardTop: ['INSTRUMENTS_PANEL'],
} satisfies Record<PhotoCheckerSilhouettePart, PhotoCheckerPhotoTypeSaleVehiclePhoto[]>;

// Valid eval codes with no dedicated marker or fill shape in this SVG (excludes `photoCheckerPhotoTypesErrored`).
export const photoCheckerPhotoTypesWithoutSvgPart = [
  'EXTERIOR_CLOSEUP',
  'OTHER_INTERIOR_FEATURES',
] satisfies PhotoCheckerPhotoTypeSaleVehiclePhoto[];

/** Classifications where the API still returns a score, but the album badge must show N/A instead of a percentage. */
export const photoCheckerPhotoTypesErrored = [
  'GENERAL_ADVERTISING',
  'UNABLE_TO_CLASSIFY',
  'WAITING_FOR_PROCESSING',
  'PHOTO_NOT_AVAILABLE',
  'PHOTO_NOT_EXISTING',
] satisfies PhotoCheckerPhotoTypeSaleVehiclePhoto[];
